import { all, call, take, fork, actionChannel } from 'redux-saga/effects';
import { notification } from 'antd'


export function* watchNotifications() {

  const notificationRequest = yield actionChannel('TOAST_SHOW')

  while (true) {
    const { payload } = yield take(notificationRequest)
    yield call(handleNotification, payload);
  }
}

export function* handleNotification(payload) {

  switch (payload.type) {
    case 'SUCCESS':
      yield notification.success({ message: payload.message });
      break;
    default:
      yield notification.success({ message: payload.message });
      break;
  }
}

export function* rootSaga() {
  yield all([
    fork(watchNotifications),
  ]);
}

export default rootSaga;